"use client";

// Lives in the layout so audio playback survives route changes.

import type { PodcastSeason } from "@/lib/podcast";

import { PlayerProvider, useMediaSessionMetadata } from "./podcast-player";

export function PodcastPlayerMount({
  children,
  seasons,
}: {
  children: React.ReactNode;
  seasons: PodcastSeason[];
}) {
  // MiniPlayer is rendered by the layout (before the footer) for a sensible
  // keyboard tab order; it still lives inside this provider.
  return (
    <PlayerProvider seasons={seasons}>
      {children}
      <PlayerSideEffects />
    </PlayerProvider>
  );
}

function PlayerSideEffects() {
  useMediaSessionMetadata();
  return null;
}
